module.exports = __webpack_public_path__ + "static/media/partner-fundacao.d9c4994a.svg";